"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Star = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lib_1 = require("../../lib");
const elements_1 = require("../../elements");
const Star = ({ light, selected = false, onChange }) => {
    const [select, setSelect] = (0, react_1.useState)(selected);
    const handleChange = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        setSelect(!select);
        if (onChange)
            onChange(!select);
    }, [select, onChange, selected]);
    (0, react_1.useEffect)(() => {
        setSelect(selected);
    }, [selected]);
    return (0, react_1.useMemo)(() => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)((0, lib_1.bem)('star', (0, lib_1.use)(light, '--light'))), onClick: handleChange }, { children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { className: (0, lib_1.classnames)((0, lib_1.bem)('star__icon', (0, lib_1.use)(select, '--selected'))), name: select ? 'starFilled' : 'starOutline' }, void 0) }), void 0)), [selected, select]);
};
exports.Star = Star;
//# sourceMappingURL=Star.js.map